<template>    
    <div class="footer-newsletter mb-50 pd-50">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="section-title mb-30 wow fadeInLeft">
                    <h2>{{$t(`StoreFront.SubscribeOurNewsletter`)}}</h2>
                    <p>{{$t(`StoreFront.Signupnewsletter`)}}</p>
                </div>
            </div>
            <div class="col-lg-6">
                <div v-if="showForm" class="newsletter-form mb-30 wow fadeInRight">
                    <Form ref="form1" autocomplete="off" @submit="onSubmit" :validation-schema="schema" v-slot="{errors}">
                        <div class="form_group">
                            <label><i class="far fa-envelope-open"></i></label>
                            <Field type="text" name="emailname" v-model="emailValuecomp.EmailValue"
                                   :class="{ 'form_control' : true ,'is-invalid': errors.emailname }"
                                     :placeholder="$t('StoreFront.EmailAddress')" />
                            <div class="invalid-feedback">{{errors.emailname}}</div>
                            <button type="submit" class="main-btn btn-green">{{$t(`StoreFront.Subscribe`)}}<i class="fa fa-angle-double-right"></i></button>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Form, Field } from 'vee-validate';
    export default {
        components: {
            Form, Field
        },
        props: ['schema',"emailValuecomp"],
        emits: ["submitNewsLetter"],
        data() {
            return {
                showForm: true
            }
        },
        methods: {
            onSubmit() {              
                this.showForm = false;                
                this.$emit("submitNewsLetter", this.emailValuecomp.EmailValue);
            }            
        }
    }
</script>